import { Typography } from 'antd'

export const TextOnePhoto = () => {
  return <Typography.Text style={{ display: 'block', fontSize: '12px',marginBottom: '12px;' }}>
  • Вы можете загрузить только 1 фото вариации. <br />
  • Минимальный формат: 600x600 px <br />
  • Рекомендуемый формат 900x1200 <br />
  • Поддерживаются форматы JPG, JPEG, PNG, WebP{' '}
  </Typography.Text>
}